import { useContext, useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { FaImage } from "react-icons/fa6";
import TokoSelectorDialog from "../../../dialogs/selectors/TokoSelectorDialog";
import ProdukKategoriSelectorDialog from "../../../dialogs/selectors/ProdukKategoriSelectorDialog";
import EditTokoDialog from "../../../dialogs/EditTokoDialog";
import EditProdukKategoriDialog from "../../../dialogs/EditProdukKategoriDialog";
import TakeImageOptionDialog from "../../../dialogs/TakeImageOptionDialog";
import { useSelector } from "react-redux";
import UiContext from "../../../store/ui-context";
import { confirmDialog } from "primereact/confirmdialog";
import { SelectButton } from "primereact/selectbutton";
import AppContext from "../../../store/app-context";
import TakeCameraImageDialog from "../../../dialogs/TakeCameraImageDialog";
import useAPIRequest from "../../../custom_hooks/simple/useAPIRequest";
import useAPIFileManagerRequest from "../../../custom_hooks/simple/useAPIFileManagerRequest";
import { format } from "date-fns";
import base64ToBlob from "../../../utils/Base64ToBlob";
import getExtensionFromMime from "../../../utils/GetExtensionFromMime";

const defaultNewCategory = {
  index: 0,
  gambar: null,
  nama: "",
  status: 1,
  keterangan: "",
};

const defaultNewToko = {
  kota_id: null,
  data_kota: null,
  nama_toko: "",
  nama_pemilik: "",
  telepon: "",
  jam_buka: "",
  alamat: "",
  longitude: 0,
  latitude: 0,
  gambar: null,
  keterangan: "",
};

const ProdukEditPage = () => {
  const navigate = useNavigate();
  const uiContext = useContext(UiContext);
  const { id } = useParams();
  const fileInputRef = useRef(null);

  const { requestGet, requestGetOne, requestPost, requestDelete, loading } =
    useAPIRequest();

  const {
    requestGet: requestGetFM,
    requestGetOne: requestGetOneFM,
    requestPost: requestPostFM,
    requestDelete: requestDeleteFM,
    loading: loadingFM,
  } = useAPIFileManagerRequest();

  const appContext = useContext(AppContext);
  const loggedId = useSelector((state) => state.auth.loggedIn);

  const [error, setError] = useState({});

  const [produk, setProduk] = useState({
    nama: "-",
    harga: 0,
    data_produk_kategori: { nama: "" },
    // data_toko: {
    //   nama_toko: "",
    //   nama_pemilik: "",
    //   alamat: "",
    //   telepon: "",
    //   jam_buka: "",
    // },
    keterangan: "",
    telepon: "",
    alamat: "",
    nama_pemilik: "",
    nama_toko: "",
  });
  const [showTokoDetail, setShowTokoDetail] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);

  const [showSelectTokoDialog, setShowSelectTokoDialog] = useState(false);
  const [showSelectProdukKategoriDialog, setShowSelectProdukKategoriDialog] =
    useState(false);

  const [showCameraPreviewDialog, setShowCameraPreviewDialog] = useState(false);
  const [cameraPreviewDialogData, setCameraPreviewDialogData] = useState({});

  const [showEditTokoDialog, setShowEditTokoDialog] = useState(false);
  const [showEditProdukKategoriDialog, setShowEditProdukKategoriDialog] =
    useState(false);
  const [showTakeImageOptionDialog, setShowTakeImageOptionDialog] =
    useState(false);

  const [editTokoData, setEditTokoData] = useState({});
  const [editProdukKategoriData, setEditProdukKategoriData] = useState({});

  // useeffect section
  useEffect(() => {
    if (!loggedId) {
      navigate(-1);
    }

    if (id === "new") {
    } else {
      if (id && id > 0) {
        fetchProduk(id);
      }
    }
  }, []);

  // call api section
  const fetchProduk = async (produkId) => {
    return requestGetOne({
      fullUrl: `/api/masterdata/produk/one/${produkId}`,
      onSuccess: ({ pagination, message, data }) => {
        if (data) {
          setProduk(data);
          const _galleryImages = [];
          if (data.gambar) {
            _galleryImages.push({
              id: 0,
              image: data.gambar,
              alt: "alt-gambar-0",
              title: "title-gambar-0",
            });
          }
          if (data.data_produk_gambars) {
            for (let i = 0; i < data.data_produk_gambars.length; i++) {
              _galleryImages.push({
                id: data.data_produk_gambars[i].id,
                image: data.data_produk_gambars[i].gambar,
                alt: `alt-gambar-${i + 1}`,
                title: `title-gambar-${i + 1}`,
              });
            }
          }
          setGalleryImages(_galleryImages);
        }
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const saveProduk = async () => {
    // refine save body
    const _produk = reformatSaveData(produk);

    return requestPost({
      fullUrl: `/api/masterdata/produk/save`,
      body: _produk,
      onSuccess: ({ pagination, message, data }) => {
        navigate(-1);
        uiContext.showSuccessMsg("Success", message);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const saveProdukKategori = async (saveData) => {
    // refine save body
    const _produkKategori = saveData;

    return requestPost({
      fullUrl: `/api/masterdata/produkkategori/save`,
      body: _produkKategori,
      onSuccess: ({ pagination, message, data }) => {
        uiContext.showSuccessMsg("Success", message);

        let found = false;
        for (let i = 0; i < produk.data_produk_kategoris.length; i++) {
          const category = produk.data_produk_kategoris[i];
          if (category.id === data.id) {
            found = true;
            break;
          }
        }

        let newDataProdukKategoris;
        if (found) {
          newDataProdukKategoris = produk.data_produk_kategoris.map((item) =>
            item.id === data.id ? data : item
          );
        } else {
          newDataProdukKategoris = [...produk.data_produk_kategoris, data];
        }

        setProduk({
          ...produk,
          data_produk_kategoris: newDataProdukKategoris,
        });
        setShowEditProdukKategoriDialog(false);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const saveToko = async (saveData) => {
    // refine save body
    const _toko = saveData;
    _toko.kota_id = appContext.selectedKota.id;
    _toko.data_kota = appContext.selectedKota;

    return requestPost({
      fullUrl: `/api/masterdata/toko/save`,
      body: _toko,
      onSuccess: ({ pagination, message, data }) => {
        uiContext.showSuccessMsg("Success", message);
        setProduk({
          ...produk,
          data_toko: data,
          toko_id: data.id,
        });
        setShowEditTokoDialog(false);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  const saveBase64Image = async ({ index, base64Image }) => {
    const blob = base64ToBlob(base64Image);
    const folderName = format(new Date(), "yyyy-MM-dd");
    const fileName = `image-file-${format(new Date(), "HH-mm")}-${Math.ceil(
      Math.random() * 1000
    )}.jpg`;

    const file = new File([blob], fileName, { type: "image/jpeg" });
    const formData = new FormData();

    formData.append("file", file);
    formData.append("folder_name", folderName);

    requestPostFM({
      fullUrl: `/api/file/addfilespecial`,
      formBody: formData,
      isForm: true,
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data, message }) => {
        const url = data.url;
        if (url) {
          const _galleryImages = [...galleryImages];
          if (index >= _galleryImages.length) {
            _galleryImages.push({
              ..._galleryImages[index],
              image: url,
            });
          } else {
            _galleryImages[index] = {
              ..._galleryImages[index],
              image: url,
            };
          }
          setGalleryImages(_galleryImages);
        }
      },
    });
  };

  const saveImage = async ({ index, file }) => {
    // const blob = base64ToBlob(base64Image);
    const mimeType = file.type; // eg: image/png
    const fileExtension = getExtensionFromMime(mimeType);

    const folderName = format(new Date(), "yyyy-MM-dd");
    const fileName = `image-file-${format(new Date(), "HH-mm")}-${Math.ceil(
      Math.random() * 1000
    )}.${fileExtension}`;

    const _file = new File([file], fileName, { type: mimeType });
    // const file = new File([blob], fileName, { type: "image/jpeg" });
    const formData = new FormData();
    formData.append("file", _file);
    formData.append("folder_name", folderName);

    requestPostFM({
      fullUrl: `/api/file/addfilespecial`,
      formBody: formData,
      isForm: true,
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data, message }) => {
        const url = data.url;
        if (url) {
          const _galleryImages = [...galleryImages];
          if (index >= _galleryImages.length) {
            _galleryImages.push({
              ..._galleryImages[index],
              image: url,
            });
          } else {
            _galleryImages[index] = {
              ..._galleryImages[index],
              image: url,
            };
          }
          setGalleryImages(_galleryImages);
        }
      },
    });
  };

  // other function section
  const hapusKategoriDariMenu = (kategori) => {
    const newDataProdukKategoris = produk.data_produk_kategoris.filter(
      (item) => item.id !== kategori.id
    );

    setProduk({
      ...produk,
      data_produk_kategoris: newDataProdukKategoris,
    });
  };

  const reformatSaveData = (data) => {
    const _produk = { ...produk };
    _produk.gambar = galleryImages.length >= 1 ? galleryImages[0].image : null;
    const data_produk_gambars = [];
    for (let i = 1; i < galleryImages.length; i++) {
      const data_produk_gambar = {
        id: galleryImages[i].id,
        gambar: galleryImages[i].image,
        produk_id: produk.id,
        status: 1,
        index: i,
      };
      if (!data_produk_gambar.id) {
        delete data_produk_gambar.id;
      }
      data_produk_gambars.push(data_produk_gambar);
    }
    _produk.data_produk_gambars = data_produk_gambars;
    _produk.keterangan = _produk.keterangan ?? "";

    if (_produk.data_toko) {
      _produk.toko_id = _produk.data_toko.id;
      _produk.nama_toko = _produk.data_toko.nama_toko;
      _produk.nama_pemilik = _produk.data_toko.nama_pemilik;
      _produk.alamat = _produk.data_toko.alamat;
      _produk.telepon = _produk.data_toko.telepon;
      _produk.jam_buka = _produk.data_toko.jam_buka;
    } else {
      _produk.toko_id = null;
    }

    if (
      _produk.data_produk_kategoris &&
      _produk.data_produk_kategoris.length > 0
    ) {
      const listKategoriId = _produk.data_produk_kategoris.map(
        (item) => item.id
      );
      _produk.data_produk_kategoris = listKategoriId;
    }

    // if (_produk.data_produk_kategori) {
    //   _produk.produk_kategori_id = _produk.data_produk_kategori.id;
    // } else {
    //   _produk.produk_kategori_id = null;
    // }

    const _selectedKota = appContext.selectedKota;
    if (_selectedKota) {
      _produk.kota_id = _selectedKota.id;
      _produk.data_kota = null;
    } else {
      _produk.kota_id = null;
      _produk.data_kota = null;
    }

    return _produk;
  };

  // ui handler section
  const handleOnConfirmChangeToko = (e, listSelecteds) => {
    if (listSelecteds && listSelecteds.length > 0) {
      const selected = listSelecteds[0];
      setProduk({ ...produk, data_toko: selected, toko_id: selected.id });
      setShowSelectTokoDialog(false);
    }
  };

  const handleOnConfirmEditToko = () => {
    saveToko(editTokoData);
  };

  const handleOnClickChangeToko = () => {
    setShowSelectTokoDialog(true);
  };

  const handleOnClickClearToko = () => {
    const accept = async () => {
      setProduk({
        ...produk,
        data_toko: null,
        toko_id: null,
        nama_pemilik: "",
        nama_toko: "",
      });
    };

    const reject = () => {};

    confirmDialog({
      message: `Kosongkan Toko?`,
      header: "Konfirmasi ",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      acceptLabel: "Ya",
      rejectLabel: "Batal",
      acceptClassName: "p-button-danger",
      accept,
      reject,
    });
  };

  const handleOnClickEditToko = () => {
    setEditTokoData(
      produk.data_toko ? { ...produk.data_toko } : { ...defaultNewToko }
    );
    setShowEditTokoDialog(true);
  };

  const handleOnClickAddNewToko = () => {
    setEditTokoData({ ...defaultNewToko });
    setShowEditTokoDialog(true);
  };

  const handleOnConfirmChangeProdukKategori = (e, listSelecteds) => {
    if (listSelecteds && listSelecteds.length > 0) {
      const selected = listSelecteds[0];

      const newDataProdukKategoris = [
        ...produk.data_produk_kategoris,
        selected,
      ];

      setProduk({
        ...produk,
        data_produk_kategoris: newDataProdukKategoris,
      });
      setShowSelectProdukKategoriDialog(false);
    }
  };

  const handleOnConfirmEditProdukKategori = () => {
    saveProdukKategori(editProdukKategoriData);
  };

  const handleOnClickChangeProdukKategori = () => {
    setShowSelectProdukKategoriDialog(true);
  };

  const handleOnClickEditProdukKategori = (kategori) => {
    setEditProdukKategoriData(kategori);
    setShowEditProdukKategoriDialog(true);
  };

  const handleOnClickAddNewProdukKategori = () => {
    setEditProdukKategoriData({ ...defaultNewCategory });
    setShowEditProdukKategoriDialog(true);
  };

  const handleOnClickImageButton = (index) => {
    setCameraPreviewDialogData({ index });
    setShowTakeImageOptionDialog(true);
  };

  const handleOnClickImageFromCamera = () => {
    setShowCameraPreviewDialog(true);
    setShowTakeImageOptionDialog(false);
  };

  const handleOnClickImageFromGallery = () => {
    fileInputRef.current.click();
    setShowTakeImageOptionDialog(false);
  };

  const handleOnClickSave = () => {
    saveProduk();
  };

  const handleOnClickDelete = () => {
    const accept = async () => {
      // dispatch(logout());
      uiContext.showSuccessMsg("Success", "Menu berhasil dihapus");
    };

    const reject = () => {};

    confirmDialog({
      message: `Hapus menu?`,
      header: "Konfirmasi ",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      acceptLabel: "Hapus",
      rejectLabel: "Batal",
      acceptClassName: "p-button-danger",
      accept,
      reject,
    });
  };

  const handleConfirmCameraPreview = (base64Image) => {
    if (base64Image) {
      setShowCameraPreviewDialog(false);

      const { index } = cameraPreviewDialogData;

      saveBase64Image({ index: index, base64Image });
    }
  };

  const handleUploadImage = (event) => {
    // console.log("EVENT", event.target);
    const file = event.target.files[0];
    const { index } = cameraPreviewDialogData;
    if (file) {
      saveImage({ index, file });
    }
  };

  const handleOnKategoriEdit = (kategori) => {
    handleOnClickEditProdukKategori(kategori);
  };

  const handleOnKategoriDelete = (kategori) => {
    const accept = async () => {
      hapusKategoriDariMenu(kategori);
      uiContext.showSuccessMsg("Success", "Kategori berhasil dihapus");
    };

    const reject = () => {};

    confirmDialog({
      message: `Hapus kategori dari menu?`,
      header: "Konfirmasi ",
      icon: "pi pi-exclamation-triangle",
      defaultFocus: "accept",
      acceptLabel: "Hapus",
      rejectLabel: "Batal",
      acceptClassName: "p-button-danger",
      accept,
      reject,
    });
  };

  // custom ui section

  const CategoryButton = ({ kategori, onDelete, onEdit }) => {
    return (
      <div
        key={kategori.id}
        className="row-start-center bg-indigo-100 pl-4 pr-1 py-1 rounded-md gap-4"
      >
        <span className="font-semibold text-slate-600">{kategori.nama} </span>
        <div className="row-start-center gap-1">
          <Button
            className="max-w-[2rem] max-h-[2rem]"
            icon="pi pi-pencil"
            onClick={() => onEdit(kategori)}
          />
          <Button
            className="max-w-[2rem] max-h-[2rem]"
            icon="pi pi-times"
            onClick={() => onDelete(kategori)}
          />
        </div>
      </div>
    );
  };

  const ImageButton = ({ className, placeholder, icon, onClick, image }) => {
    return (
      <div
        className={`col-center-center ${className} border-dashed border-slate-200 border-2 gap-2 hover:bg-stone-100 active:bg-stone-100 cursor-pointer p-1`}
        onClick={(e) => {
          if (onClick) onClick(e);
        }}
      >
        {!image && (
          <div className={`col-center-center gap-2`}>
            <FaImage className="text-slate-300 text-5xl" />
            <span className="text-lg font-semibold text-slate-300">
              {" "}
              {placeholder ?? ""}{" "}
            </span>
          </div>
        )}
        {image && (
          <img
            src={image}
            alt={`gambar-${placeholder}`}
            className="object-cover w-full h-full"
          />
        )}
      </div>
    );
  };

  return (
    <div className="relative col-start-start gap-1">
      <div className="fixed z-50 bottom-4 right-3 row-center-center p-1 gap-2">
        <Button
          className="!p-7 shadow-lg hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-75"
          rounded
          loading={loading}
          severity="danger"
          icon={"pi pi-trash"}
          pt={{ icon: { className: "!text-xl" } }}
          onClick={handleOnClickDelete}
        />
        <Button
          className="!p-7 shadow-lg hover:bg-emerald-600 focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:ring-opacity-75"
          rounded
          loading={loading}
          severity="success"
          icon={"pi pi-save"}
          pt={{ icon: { className: "!text-xl" } }}
          onClick={handleOnClickSave}
        />
      </div>

      <TakeCameraImageDialog
        title="Ambil Foto"
        visible={showCameraPreviewDialog}
        onHide={() => setShowCameraPreviewDialog(false)}
        onConfirm={handleConfirmCameraPreview}
      />

      <TakeImageOptionDialog
        visible={showTakeImageOptionDialog}
        onHide={() => setShowTakeImageOptionDialog(false)}
        onClickTakePicture={handleOnClickImageFromCamera}
        onClickFromGallery={handleOnClickImageFromGallery}
      />

      <TokoSelectorDialog
        title="Pilih Toko"
        additionalFilter={`kota_id:=:${appContext.selectedKota?.id ?? 0}`}
        visible={showSelectTokoDialog}
        onHide={() => setShowSelectTokoDialog(false)}
        onConfirm={handleOnConfirmChangeToko}
      />

      <EditTokoDialog
        addNewMode={editTokoData.id ? false : true}
        data={editTokoData}
        setData={setEditTokoData}
        loading={loading}
        error={error}
        setError={setError}
        visible={showEditTokoDialog}
        onHide={() => setShowEditTokoDialog(false)}
        onConfirm={handleOnConfirmEditToko}
      />

      <ProdukKategoriSelectorDialog
        title="Pilih Kategori"
        visible={showSelectProdukKategoriDialog}
        onHide={() => setShowSelectProdukKategoriDialog(false)}
        onConfirm={handleOnConfirmChangeProdukKategori}
      />

      <EditProdukKategoriDialog
        addNewMode={editProdukKategoriData.id ? false : true}
        data={editProdukKategoriData}
        setData={setEditProdukKategoriData}
        loading={loading}
        error={error}
        setError={setError}
        visible={showEditProdukKategoriDialog}
        onHide={() => setShowEditProdukKategoriDialog(false)}
        onConfirm={handleOnConfirmEditProdukKategori}
      />

      <div className="col-start-start bg-white w-full shadow-xs px-3 py-3 gap-2">
        <Link className="row-start-center px-1 gap-3" to={-1}>
          <i className="pi pi-arrow-left text-slate-600" />
          <span className="text-slate-600"> Batal</span>
        </Link>
      </div>

      <div className="col-start-start bg-white w-full shadow-xs px-3 py-4 gap-2">
        <div className="col-start-start gap-5 w-full">
          <div className="row-end-center w-full gap-2">
            <Button
              className="max-h-[2rem] w-[8.3rem]"
              label="Ganti Toko"
              icon="pi pi-search"
              onClick={() => handleOnClickChangeToko()}
              rounded
            />
            <Button
              className="max-h-[2rem] max-w-[2rem]"
              icon="pi pi-times"
              severity="warning"
              outlined
              onClick={() => handleOnClickClearToko()}
              rounded
            />
            <Button
              className="max-h-[2rem] max-w-[2rem]"
              icon="pi pi-pencil"
              outlined
              onClick={() => handleOnClickEditToko()}
              rounded
            />
            <Button
              className="max-h-[2rem] max-w-[2rem]"
              icon="pi pi-plus"
              outlined
              onClick={() => handleOnClickAddNewToko()}
              rounded
            />
          </div>

          {/* field nama toko */}
          <div className={`col-start-start gap-1 w-full`}>
            <span className="text-[0.8rem] font-semibold text-slate-400 tracking-wide leading-tight">
              NAMA TOKO
            </span>
            <InputTextarea
              variant="filled"
              readOnly
              value={
                produk.data_toko
                  ? produk.data_toko.nama_toko
                  : produk.nama_toko ?? ""
              }
              // rows={10}
              className="w-full"
              onChange={(e) => {
                setProduk({ ...produk, nama_toko: e.target.value });
              }}
            />
          </div>

          {/* field pemilik */}
          <div className={`col-start-start gap-1 w-full`}>
            <span className="text-[0.8rem] font-semibold text-slate-400 tracking-wide leading-tight">
              PEMILIK
            </span>
            <InputText
              variant="filled"
              readOnly
              value={
                produk.data_toko
                  ? produk.data_toko.nama_pemilik
                  : produk.nama_pemilik ?? ""
              }
              // rows={10}
              className="w-full"
              onChange={(e) => {
                setProduk({ ...produk, nama_pemilik: e.target.value });
              }}
            />
          </div>

          {/* field alamat toko */}
          <div className={`col-start-start gap-1 w-full`}>
            <span className="text-[0.8rem] font-semibold text-slate-400 tracking-wide leading-tight">
              ALAMAT TOKO
            </span>
            <InputTextarea
              value={
                produk.data_toko ? produk.data_toko.alamat : produk.alamat ?? ""
              }
              variant={produk.data_toko ? "filled" : "outlined"}
              readOnly={produk.data_toko ? true : false}
              rows={4}
              className="w-full"
              onChange={(e) => {
                setProduk({ ...produk, alamat: e.target.value });
              }}
            />
          </div>

          {/* field jam buka */}
          <div className={`col-start-start gap-1 w-full`}>
            <span className="text-[0.8rem] font-semibold text-slate-400 tracking-wide leading-tight">
              JAM BUKA
            </span>
            <InputText
              variant={produk.data_toko ? "filled" : "outlined"}
              readOnly={produk.data_toko ? true : false}
              value={
                produk.data_toko
                  ? produk.data_toko.jam_buka
                  : produk.jam_buka ?? ""
              }
              // rows={10}
              className="w-full"
              onChange={(e) => {
                setProduk({ ...produk, jam_buka: e.target.value });
              }}
            />
          </div>

          {/* field Telepon */}
          <div className={`col-start-start gap-1 w-full`}>
            <span className="text-[0.8rem] font-semibold text-slate-400 tracking-wide leading-tight">
              TELEPON
            </span>
            <InputText
              variant={produk.data_toko ? "filled" : "outlined"}
              readOnly={produk.data_toko ? true : false}
              value={
                produk.data_toko
                  ? produk.data_toko.telepon
                  : produk.telepon ?? ""
              }
              className="w-full"
              onChange={(e) => {
                setProduk({ ...produk, telepon: e.target.value });
              }}
            />
          </div>
        </div>
      </div>

      <div className="col-start-start bg-white w-full shadow-xs pt-4 pb-4">
        <div className="col-start-start px-3 w-full gap-5">
          {/* field gambar */}
          <div className="col-start-center w-full gap-2">
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={(event) => handleUploadImage(event)}
            />
            <ImageButton
              className="w-full h-[calc(4/5*100vw)]"
              placeholder={"Gambar Utama"}
              image={galleryImages.length >= 1 ? galleryImages[0].image : null}
              onClick={() => handleOnClickImageButton(0)}
            />
            <div className="row-center-center w-full gap-2">
              <ImageButton
                className="w-full h-[calc(4/5*50vw)]"
                placeholder={"Extra 1"}
                image={
                  galleryImages.length >= 2 ? galleryImages[1].image : null
                }
                onClick={() => handleOnClickImageButton(1)}
              />
              <ImageButton
                className="w-full h-[calc(4/5*50vw)]"
                placeholder={"Extra 2"}
                image={
                  galleryImages.length >= 3 ? galleryImages[2].image : null
                }
                onClick={() => handleOnClickImageButton(2)}
              />
            </div>
            <div className="row-center-center w-full gap-2">
              <ImageButton
                className="w-full h-[calc(4/5*50vw)]"
                placeholder={"Extra 3"}
                image={
                  galleryImages.length >= 4 ? galleryImages[3].image : null
                }
                onClick={() => handleOnClickImageButton(3)}
              />
              <ImageButton
                className="w-full h-[calc(4/5*50vw)]"
                placeholder={"Extra 4"}
                image={
                  galleryImages.length >= 5 ? galleryImages[4].image : null
                }
                onClick={() => handleOnClickImageButton(4)}
              />
            </div>
          </div>

          {/* field nama */}
          <div className={`col-start-start gap-1 w-full`}>
            <span className="text-[0.8rem] font-semibold text-slate-400 tracking-wide leading-tight">
              NAMA MENU
            </span>
            <InputTextarea
              value={produk.nama}
              className="w-full"
              onChange={(e) => {
                setProduk({ ...produk, nama: e.target.value });
              }}
            />
          </div>

          {/* field harga */}
          <div className={`col-start-start gap-1 w-full`}>
            <span className="text-[0.8rem] font-semibold text-slate-400 tracking-wide leading-tight">
              HARGA
            </span>
            <InputNumber
              buttonLayout="horizontal"
              showButtons
              value={produk.harga}
              className="max-w-[7rem]"
              onChange={(e) => {
                setProduk({ ...produk, harga: e.value });
              }}
              step={1000}
              pt={{ input: { root: { className: "max-w-[7rem]" } } }}
            />
          </div>

          {/* field rekomendasi */}
          <div className={`col-start-start gap-1 w-full`}>
            <span className="text-[0.8rem] font-semibold text-slate-400 tracking-wide leading-tight">
              REKOMENDASI & URUTAN
            </span>
            <div className="row-start-center gap-4">
              <SelectButton
                value={produk.rekomendasi > 0 ? "Ya" : "Tidak"}
                options={["Ya", "Tidak"]}
                onChange={(e) => {
                  setProduk({
                    ...produk,
                    rekomendasi: e.value === "Ya" ? 1 : 0,
                  });
                }}
              />

              <InputNumber
                buttonLayout="horizontal"
                showButtons
                value={produk.rekomendasi_index}
                className="max-w-[4rem]"
                onChange={(e) => {
                  setProduk({ ...produk, rekomendasi_index: e.value });
                }}
                step={1}
                pt={{ input: { root: { className: "max-w-[4rem]" } } }}
              />
            </div>
          </div>

          {/* field kategori */}
          <div className={`col-start-start gap-1 w-full`}>
            <span className="text-[0.8rem] font-semibold text-slate-400 tracking-wide leading-tight">
              KATEGORI
            </span>
            <div className="row-start-center gap-2 w-full">
              {/* <InputText
                variant="filled"
                readOnly
                value={
                  produk.data_produk_kategori
                    ? produk.data_produk_kategori.nama
                    : "-"
                }
                // rows={10}
                className="w-full"
              /> */}

              {/* <Button
                className="max-h-[2rem] max-w-[2rem]"
                icon="pi pi-search"
                outlined
                rounded
                onClick={() => handleOnClickChangeProdukKategori()}
              /> */}

              {/* <Button
                className="max-h-[2rem] max-w-[2rem]"
                icon="pi pi-pencil"
                outlined
                rounded
                onClick={() => handleOnClickEditProdukKategori()}
              /> */}

              <Button
                className="max-h-[2rem] max-w-[2rem]"
                icon="pi pi-plus"
                outlined
                rounded
                onClick={() => handleOnClickChangeProdukKategori()}
              />

              <Button
                className="max-h-[2rem]"
                icon="pi pi-plus"
                label="Kategori Baru"
                outlined
                rounded
                onClick={() => handleOnClickAddNewProdukKategori()}
              />
            </div>
            {produk.data_produk_kategoris &&
              produk.data_produk_kategoris.length > 0 && (
                <div className="row-start-start pt-2 gap-2 flex-wrap">
                  {produk.data_produk_kategoris.map((item, index) =>
                    CategoryButton({
                      kategori: item,
                      onDelete: handleOnKategoriDelete,
                      onEdit: handleOnKategoriEdit,
                      onEdit: handleOnKategoriEdit,
                    })
                  )}
                </div>
              )}
          </div>

          {/* field keterangan */}
          <div className={`col-start-start gap-1 w-full`}>
            <span className="text-[0.8rem] font-semibold text-slate-400 tracking-wide leading-tight">
              DESKRIPSI
            </span>
            <InputTextarea
              value={produk.keterangan}
              rows={10}
              className="text-sm w-full"
              onChange={(e) => {
                setProduk({ ...produk, keterangan: e.target.value });
              }}
            />
          </div>

          {/* field bahan */}
          <div className={`col-start-start gap-1 w-full`}>
            <span className="text-[0.8rem] font-semibold text-slate-400 tracking-wide leading-tight">
              BAHAN
            </span>
            <InputTextarea
              value={produk.bahan}
              rows={10}
              className="text-sm w-full"
              onChange={(e) => {
                setProduk({ ...produk, bahan: e.target.value });
              }}
            />
          </div>
        </div>

        <div className="py-3 h-[4.5rem]" />
        {/* <div className="w-full px-3 py-6">
          <Button
            className="w-full min-h-[3rem]"
            label="SIMPAN"
            icon="pi pi-save"
          />
        </div> */}
      </div>
    </div>
  );
};

export default ProdukEditPage;
